"use client";
import { Close } from "@/components/newIcons/Close";
import { InfoCircle } from "@/components/newIcons/InfoCircle";
import { type ReactNode, useState } from "react";

type Props = {
  children: ReactNode;
};
export const Info = ({ children }: Props) => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <>
      <InfoCircle className="w-4 h-4 text-pr-1 ml-2 cursor-pointer lg:hidden" onClick={() => setShowInfo(!showInfo)} />
      {showInfo && (
        <div className="z-10 bg-white text-xs leading-5 font-normal p-5 absolute border border-[#E5E5E5] rounded-[5px] shadow-sm top-full left-0 right-0">
          <p className="font-bold flex items-center justify-between">
            Informations
            <Close className="w-4 h-4 cursor-pointer" onClick={() => setShowInfo(false)} />
          </p>
          {children}
        </div>
      )}
    </>
  );
};
